import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/4/thumb-landscape.jpg"

const Post4 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">LOEWE／ハンモックドローストリングミニ／15 x18 x11cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          おしゃれプロたちがこぞって愛用するLOEWE（ロエベ）のバッグ。大人の女性であれば１つは持っておきたいブランドではないでしょうか。ロエベが誇る上質な素材と卓逸した技術によって作られるバッグは瞬く間にファッショニスタたちの間で話題になり、トレンドバッグとしてSNSや雑誌などで引っ張りだこです。持っているだけでこなれた印象を与え、トレンド感溢れるスタイルに魅せてくれるロエベの大人気バッグ１０選をご紹介します。ぜひ参考にしてみてください♪
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>ハンモック（Hammock）</h2>
          <p>2016年のデビュー以降、根強い人気を集め、まさにロエベの顔ともいえる存在となった「ハンモック」。サイズはミディアム・スモール・ミニの３展開。サイドジップの開閉やショルダーの調整で様々な表情（なんと6WAY仕様！）を楽しめるのも人気の理由。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/4/1.jpg" alt="" />
        </figure>
        <span className="text-center">LOEWE／ハンモックスモール／25 x25 x14cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/2.jpg" alt="" />
            <span className="text-center">LOEWE／ハンモックスモール／25 x23 x13cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/3.jpg" alt="" />
            <span className="text-center">LOEWE／ハンモックドローストリングスモール／25 x23 x13cm</span>
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ゲート（Gate）</h2>
          <p>「ゲート」は乗馬の鞍がモチーフの由来。カジュアルながら、フロントのベルトリボンがコーデにフェミニンな要素をプラスしてくれます。持ち手のついたトップハンドルタイプや半月型のショルダータイプなど、型のバリエーションも様々。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/4/4.jpg" alt="" />
        </figure>
        <span className="text-center">LOEWE／ゲートバッグスモール／27 x20 x12cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/5.jpg" alt="" />
            <span className="text-center">LOEWE／ゲートバッグスモール／27 x20 x12cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/6.jpg" alt="" />
            <span className="text-center">LOEWE／ゲートトップハンドル／30 x22 x12cm</span>
          </figure>
        </div>
        <div className="text-max-width">
          <h2>パズルバッグ（Pazzle bag）</h2>
          <p>「パズルバッグ」はクリエイティブディレクターのジョナサン・ アンダーソンがロエベに参画して初めて製作したバッグ。革新的な直方体のフォルムは日本の折り紙をモチーフに作られたそう。ラージ・レギュラー・スモール・ミニの４展開に加え、2021年にはナノサイズが登場。まだまだブームは続きそうです。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/4/7.jpg" alt="" />
        </figure>
        <span className="text-center">LOEWE／パズルバッグ／28 x17 x12cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/8.jpg" alt="" />
            <span className="text-center">LOEWE／パズルバッグ／28 x17 x11cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/9.jpg" alt="" />
            <span className="text-center">LOEWE／パズルバッグナノ／12 x8 x5cm</span> 
          </figure>
        </div>              
        <Link to="https://laxus.co/app/pc/bags/loewe" className="view-all-button">
          ロエベのバッグを見る
        </Link>
        <div className="text-max-width">
          <h2>アマソナ（Amazona）</h2>
          <p>女性の社会参加が進み始めていた1975年にデビューし、長年にわたって一世を風靡「アマソナ」。流行を問わないシンプルなデザインと必要なものを全て収納できる容量の大きさは、一つ持っておくだけでカジュアルからビジネスまで大活躍。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/4/10.jpg" alt="" />
        </figure>
        <span className="text-center">LOEWE／アマソナ28／29 x16 x12cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/11.jpg" alt="" />
            <span className="text-center">LOEWE／アマソナ28／28 x17 x13cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/12.jpg" alt="" />
            <span className="text-center">LOEWE／アマソナ28／28 x16 x13cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>フラメンコ(Flamenco)</h2>
          <p>1984年にデビューした「フラメンコ」は、柔らかいレザーの質感と驚くほどの軽さが魅力。ドローストリングスを絞ることでクシュっと巾着型に、荷物が多いときは緩めてスクエア型にして持つことも可能。2018年にはトートタイプのものも登場し、時代とともに進化を遂げながら愛され続けています。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/4/13.jpg" alt="" />
        </figure>
        <span className="text-center">LOEWE／フラメンコクラッチミニ／23 x19 x7cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/14.jpg" alt="" />
            <span className="text-center">LOEWE／フラメンコクラッチミニ／23 x19 x7cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/15.jpg" alt="" />
            <span className="text-center">LOEWE／フラメンコ／30 x35 x11cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>クッショントート（Cushion Tote）</h2>
          <p>モダンでシンプルなデザインの「クッショントート」は、シーンを選ばず愛用できます。大容量ながら、金具を使用していないので軽量なのも嬉しいポイント。定番のキャンバスタイプ生地のものからレザータイプのものまでバリエーションもさまざま。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/4/16.jpg" alt="" />
        </figure>
        <span className="text-center">LOEWE／クッショントート／32 x24 x14cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/17.jpg" alt="" />
            <span className="text-center">LOEWE／クッショントート／32 x24 x14cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/18.jpg" alt="" />
            <span className="text-center">LOEWE／クッショントート／38 x27 x30cm</span> 
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/loewe" className="view-all-button">
          ロエベのバッグを見る
        </Link>
        <div className="text-max-width">
          <h2>バルーンバッグ（Balloon Bag）</h2>
          <p>2020SSコレクションで発表され、「パズル」や「ゲート」に続く新マストハブとして支持を得ている「バルーンバッグ」。サイズはラージ・ミディアム・スモール・ナノの４展開。バッグを閉じた時、サイドに入る計算し尽くされた美しいドレープは、ロエベならではの技術力の高さをうかがえます。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/4/19.jpg" alt="" />
        </figure>
        <span className="text-center">LOEWE／バルーンバッグスモール／18 x25 x13cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/20.jpg" alt="" />
            <span className="text-center">LOEWE／バルーンバッグスモール／18 x25 x13cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/21.jpg" alt="" />
            <span className="text-center">LOEWE／バルーンバッグナノ／9 x13 x7cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>エレファント（Elephant）</h2>
          <p>名前の通り象がモチーフで、個性的で遊び心溢れるデザインがキュートな「エレファント」。可愛らしいアニマルモチーフも、上質な素材を用いたロエベのアイテムならファッショナブルな印象に。アクセサリー感覚で気軽に取り入れてみては？</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/4/22.jpg" alt="" />
        </figure>
        <span className="text-center">LOEWE／エレファントミニバッグ／11 x15 x9cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/23.jpg" alt="" />
            <span className="text-center">LOEWE／エレファントミニバッグ／12 x17 x9cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/24.jpg" alt="" />
            <span className="text-center">LOEWE／エレファントミニバッグ／12 x16 x9cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>バスケット（Basket）</h2>
          <p>夏のコーデアイテムとして人気の高いかごバッグですが、ロエベの「バスケット」もその一つで、一度発売すると即完売という人気ぶり。ざっくりと編まれたヤシの葉に刻印入りレザーのコントラストが映える、まさに大人のためのかごバッグ。カジュアルすぎないので、キレイめのコーデにも合わせやすいですね。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/4/25.jpg" alt="" />
        </figure>
        <span className="text-center">LOEWE／バスケットバッグ／25 x25 x18cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/26.jpg" alt="" />
            <span className="text-center">LOEWE／バスケットバッグ／25 x25 x18cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/27.jpg" alt="" />
            <span className="text-center">LOEWE／ラフィアポシェット／19 x17 x10cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>バルセロナ（Barcelona）</h2>
          <p>三角形のバックルが特徴的な「バルセロナ」。素材には牛革の中でも最高峰と名高いボックスカーフを使用。小さめサイズですが、中身は２つのコンパートメントに分かれており、中央にはスリットポケットもついているので、小物収納もばっちりカバー。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/4/28.jpg" alt="" />
        </figure>
        <span className="text-center">LOEWE／バルセロナスモール／19 x11 x7cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/29.jpg" alt="" />
            <span className="text-center">LOEWE／バルセロナ／27 x26 x6cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/4/30.jpg" alt="" />
            <span className="text-center">LOEWE／バルセロナスモール／19 x11 x6cm</span> 
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/loewe" className="view-all-button">
          ロエベのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post4

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 4}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
